import { IReferenceDto } from './fileConfig'
import { ShortUserListItemDto } from './userConfig'

export interface TaskOverviewDto {
    id: string
    category?: string
    status: string
    today: boolean
    highlight: boolean
    week: boolean
    title: string
    description?: string
    file: IReferenceDto
    start?: string
    due: string
    duration?: string
    position?: number
    assignee?: ShortUserListItemDto
    assigner: ShortUserListItemDto
    attachmentIds: string[]
    workflowStepName?: string
}

export interface TaskMutationDto {
    category?: string
    status: string
    highlight: boolean
    today: boolean
    week: boolean
    title: string
    description?: string
    start?: string
    due: string
    duration?: string
    fileId: string
    assigneeId: string
    assignerId: string
    attachmentIds?: string[]
    workflowStepName?: string
}

export enum TaskAction {
    GetOverview = 'GET_TASK_OVERVIEW',
    Add = 'ADD_TASK',
    Update = 'UPDATE_TASK',
    Delete = 'DELETE_TASK',
    ResetOverview = 'RESET_TASK_OVERVIEW',
    OverviewSettings = 'TASK_OVERVIEW_SETTINGS',
}
